import { Injectable } from '@angular/core';
import * as chroma from 'chroma-js';
import { ChartModel } from '../models/chart';

export enum ColorSet {
  colorSet1,
  colorSet2,
  colorSet3,
  colorSet4,
  colorSet5,
  colorSet6,
}

@Injectable({
  providedIn: 'root',
})
export class ColoringSetService {
  private colorSets = {
    colorSet1: ['#15616D', '#E06C00', '#FFDDAD', '#77AF9C', '#001524', '#78290F', '#ACD2ED', '#C94057'],
    colorSet2: ['#CBE05B', '#6D7662', '#FDBB99', '#A2A592', '#E1B765', '#E46238', '#242424', '#7B0206'],
    colorSet3: ['#40AB60', '#003CCF', '#4F2678', '#FFD200', '#23BDFF', '#360047', '#DC0000', '#FF9100'],
    colorSet4: ['#15616D', '#E06C00', '#FFDDAD', '#77AF9C', '#001524', '#78290F', '#ACD2ED', '#C94057'],
    colorSet5: ['#15616D', '#E06C00', '#FFDDAD', '#77AF9C', '#001524', '#78290F', '#ACD2ED', '#C94057'],
    colorSet6: ['#15616D', '#E06C00', '#FFDDAD', '#77AF9C', '#001524', '#78290F', '#ACD2ED', '#C94057'],
  };

  private selectedColorSet: string[];
  constructor() { }

  generateColorSet(colorSet: ColorSet, colorsCount: number): string[] {
    let colors: string[] = [];
    this.setColorSet(colorSet);
    if (colorsCount < 9) {
      colors = this.setDistinctColor(colorsCount);
    } else {
      colors = this.setGradientColor(colorsCount);
    }
    return colors;
  }

  getDefaultColorSet(): string[] {
    return this.colorSets.colorSet1;
  }


  findColorSet(colors: string[]): any {
    const colorSets = [
      this.colorSets.colorSet1,
      this.colorSets.colorSet2,
      this.colorSets.colorSet3,
      this.colorSets.colorSet4,
      this.colorSets.colorSet5,
      this.colorSets.colorSet5,
    ];
    let colorSetIndex = null;

    for (let set = 0; set < colorSets.length; set++) {
      let colorFound = false;
      for (let index = 0; index < colorSets[set].length; index++) {
        colors.forEach(color => {
          if (color === colorSets[set][index]) {
            colorFound = true;
          }
        });
        if (colorFound) {
          break;
        }
      }
      if (colorFound) {
        colorSetIndex = set;
        break;
      }
    }

    if (colorSetIndex !== null) {
      return colorSetIndex;
    }
    return ColorSet.colorSet1;
  }

  setDistinctColor(colorsCount: number): string[] {
    const result: string[] = [];

    for (let index = 0; index < colorsCount; index++) {
      result.push(this.selectedColorSet[index]);
    }

    return result;
  }

  setGradientColor(colorsCount: number): string[] {
    const result: string[] = [];
    const gradient = chroma.scale(this.selectedColorSet).domain([0, colorsCount]);
    const level = Math.floor(colorsCount / (colorsCount - 1));
    for (let index = 0; index < colorsCount; index++) {
      result.push(gradient(index * level).hex());
    }

    return result;
  }

  setColorSet(colorSet: ColorSet) {
    switch (colorSet) {
      case ColorSet.colorSet1:
        this.selectedColorSet = this.colorSets.colorSet1;
        break;
      case ColorSet.colorSet2:
        this.selectedColorSet = this.colorSets.colorSet2;
        break;
      case ColorSet.colorSet3:
        this.selectedColorSet = this.colorSets.colorSet3;
        break;
      case ColorSet.colorSet4:
        this.selectedColorSet = this.colorSets.colorSet4;
        break;
      case ColorSet.colorSet5:
        this.selectedColorSet = this.colorSets.colorSet5;
        break;
      case ColorSet.colorSet6:
        this.selectedColorSet = this.colorSets.colorSet6;
        break;
    }
  }
}
